import { controls } from "../../controls";
const rprbi7 = {
  label: "RBI-MIS: Banking Outlet",
  starting: true,
  url: "RBI-MIS: Banking Outlet",
  pageLabel: "Banking Outlet",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.magicDateLabel({ tab: "filter", star: true, label: "As On Date", width: "col-sm-2", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", isRequired: true, default: "n" }),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "RBI Banking Outlet",
    pdfProps: { pageSize: "A3", pageOrientation: "landscape" },

    filterable: true,
    sortable: true,
    textReportProps: {
      'LBS': {
        filename: `RBI-Banking_Outlet-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },
    defaultsTo: 0,

    displayColumns: [
      {
        Header: "Branch Code",
        accessor: "branch_code",
      },
      {
        Header: "Branch Name",
        accessor: "branch_display",
      },
      {
        Header: "Total",
        accessor: "total_banking_outlets",
      },
      {
        Header: "Fixed Point",
        accessor: "fixed_point_outlets",
      },
      {
        Header: "Other BC",
        accessor: "bc_outlets",
      },
    ]
  }
};
export default rprbi7;